import { mapKeys, camelCase } from 'lodash';
import { CollectionInvestment } from '../../../../apis/backend';

// Shared helper to transform investment data for InvestmentTable
export const transformInvestmentData = (investment: CollectionInvestment): any => {
  const transformed = mapKeys(investment, (_value, key) => camelCase(key));
  // Fix field name mismatch: backend returns "price" but InvestmentTable expects "latestPrice"
  if (transformed.price && !transformed.latestPrice) {
    transformed.latestPrice = transformed.price;
  }
  return transformed;
};

export function formatLargeNumber(num: number): string {
  if (!num || typeof num !== 'number' || isNaN(num) || !isFinite(num)) {
    return '$0';
  }

  if (num >= 1e12) return `$${(num / 1e12).toFixed(1)}T`;
  if (num >= 1e9) return `$${(num / 1e9).toFixed(1)}B`;
  if (num >= 1e6) return `$${(num / 1e6).toFixed(1)}M`;
  return `$${num.toLocaleString()}`;
}

export function formatDate(dateString: string): string {
  try {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffHours / 24);

    if (diffHours < 1) return 'Just now';
    if (diffHours < 24) return `${diffHours} hour${diffHours === 1 ? '' : 's'} ago`;
    if (diffDays < 7) return `${diffDays} day${diffDays === 1 ? '' : 's'} ago`;

    return date.toLocaleDateString();
  } catch {
    return dateString;
  }
}
